<template>
  <div class="rs-image-uploader">
    <div
      class="rs-image-uploader__preview"
      :style="{
        width: `${width}px`,
        height: `${height}px`,
        backgroundImage: `url(${getUrl})`,
      }"
      @mouseover="showDeleteIcon = true"
      @mouseleave="showDeleteIcon = false"
    >
      <div
        v-if="showDeleteIcon"
        class="rs-image-uploader__delete"
        @click="toggleDelete"
      >
        <RsIcon
          weight="far"
          icon="times"
          class="rs-icon"
        />
      </div>
    </div>
    <div class="rs-image-uploader__control">
      <RsFormFile
        :id="id"
        ref="image_uploader"
        :prompt="$ts('imageUploader.promptUploadNewImage')"
        variant="btn"
        :accept="`image/jpeg,image/png,image/webp,image/gif${allowSvg ? ',image/svg+xml' : ''}`"
        @on-upload-triggered="onUpload"
        @on-file-reset="$emit('on-file-reset')"
      />
      <small class="text-muted">{{ $t('imageUploader.supportedFileTypes') }}{{ allowSvg ? ', svg' : '' }}</small>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsImageUploader',

  props: {
    id: String,
    /**
         * Url of Image
         */
    src: String,
    /**
         * Width of Preview Image region
         */
    width: {
      type: [Number, String],
      default: 120,
    },
    /**
         * Height of Preview Image region
         */
    height: {
      type: [Number, String],
      default: 80,
    },
    /**
     * Determines if SVG is an allowed mime type for the image uploader.
     */
    allowSvg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDeleteIcon: false,
      isDelete: false,
    };
  },

  computed: {
    getUrl(): string {
      return this.isDelete ? '' : this.src ?? '';
    },
  },
  methods: {
    onClickUpload() {
      (this.$refs.image_uploader! as any).onUpload();
    },

    onUpload({ files, fileDetails }: { files: FileList, fileDetails: Record<string, any>[] }) {
      this.$emit('on-upload-triggered', {
        field: this.id,
        files,
        fileDetails,
      });
    },

    toggleDelete() {
      this.isDelete = true;
      this.$emit('on-delete');
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.rs-image-uploader {
  display: flex;
  align-items: center;
  &__preview {
    position: relative;
    background: $extra-light-gray;
    border-radius: .25rem;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  &__delete{
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -6px;
    right: -6px;
    width: 20px;
    height: 20px;
    border: 2px solid $white;
    background: $error;
    border-radius: 50%;
    cursor: pointer;
    transition: background-color .2s ease;
    &:hover{
      background-color: darken($error, 10%);
    }
    .rs-icon {
      font-size: 0.75rem;
      color: $white;
    }
  }
  &__control {
    margin-left: 1rem;
    small{
      font-size: 0.75rem;
    }
  }
}
</style>
